/**
 * Утилиты для двуязычного интерфейса (рус/узб).
 */
import i18n from '../i18n';

/** Получить locale для форматирования дат */
export function getDateLocale() {
  return i18n.language === 'uz' ? 'uz-UZ' : 'ru-RU';
}

/** Получить название отдела на текущем языке */
export function getDeptName(item) {
  if (!item) return '';
  if (i18n.language === 'uz') {
    return item.department_name_uz || item.name_uz || item.department_name || item.name_ru || '';
  }
  return item.department_name || item.department_name_ru || item.name_ru || '';
}

/** Сокращение русских названий отделов для графиков */
function shortenDeptNameRu(name) {
  let short = name
    .replace('Лаборатория ', 'Лаб. ')
    .replace('лекарственных средств', 'ЛС')
    .replace('медицинского назначения', 'мед. назн.')
    .replace('медицинской техники', 'мед. техн.')
    .replace('медицинской продукции', 'мед. прод.')
    .replace('менеджмента качества', 'менедж. кач.')
    .replace('менеджмента качеством', 'менедж. кач.')
    .replace('фармацевтической деятельности', 'фарм. деят.')
    .replace('фармакологического контроля', 'фарм. контр.')
    .replace('государственных закупок и контрактов', 'гос. закупок')
    .replace('государственной фармакопеи', 'гос. фармакопеи')
    .replace('постмаркетингового надзора', 'постмаркет. надзора')
    .replace('информационных технологий', 'ИТ')
    .replace('международных отношений', 'межд. отношений')
    .replace('административно-хозяйственных дел', 'АХД')
    .replace('противодействия коррупции и комплаенс контроля', 'антикорр.')
    .replace('контроля качества и стандартизации ', 'контр. кач. ')
    .replace('контроля качества изделий ', 'контр. кач. изд. ')
    .replace('вакцин, сывороточных препаратов и микробиологических исследований', 'вакцин и микробиол.')
    .replace('фармако-токсикологических исследований', 'фарм.-токсикол.')
    .replace('специальной цифровой маркировки', 'цифр. маркировки')
    .replace('референтных цен', 'реф. цен')
    .replace('Министерства здравоохранения', 'Минздрава')
    .replace('Управление ', 'Упр. ')
    .replace('Департамент ', 'Деп. ')
    .replace('Метрологическая служба', 'Метрол. служба')
    .replace('Финансово экономический', 'Фин.-эконом.')
    .replace('Информационно-аналитический', 'Инф.-аналит.')
    .replace('Полиграфический', 'Полиграф.')
    .replace('Юридический', 'Юрид.')
    .replace('Испытательный центр', 'Испыт. центр');
  if (short.length > 30) short = short.substring(0, 28) + '…';
  return short;
}

/** Сокращение узбекских названий отделов для графиков */
function shortenDeptNameUz(name) {
  let short = name
    .replace('Laboratoriya ', 'Lab. ')
    .replace('dori vositalari', 'DV')
    .replace('tibbiy maqsadli', 'tib. maqsad.')
    .replace('tibbiy texnika', 'tib. tex.')
    .replace('tibbiy mahsulot', 'tib. mah.')
    .replace('sifat menejmenti', 'sif. menej.')
    .replace('farmatsevtik faoliyat', 'farm. faol.')
    .replace('farmakologik nazorat', 'farm. naz.')
    .replace('davlat xaridlari va shartnomalar', 'dav. xarid.')
    .replace('davlat farmakopeyasi', 'dav. farmak.')
    .replace('postmarketing kuzatuvi', 'postmark. kuz.')
    .replace('axborot texnologiyalari', 'AT')
    .replace('xalqaro munosabatlar', 'xalq. mun.')
    .replace("ma'muriy-xo'jalik ishlari", 'MXI')
    .replace('korruptsiyaga qarshi kurash', 'antikorr.')
    .replace('sifat nazorati va standartlashtirish', 'sif. naz. ')
    .replace('vaksinalar, zardobli preparatlar va mikrobiologik tadqiqotlar', 'vaksinalar va mikrobiol.')
    .replace('farmako-toksikologik tadqiqotlar', 'farm.-toks.')
    .replace('maxsus raqamli markirovka', 'raq. markirovka')
    .replace('referent narxlar', 'ref. narxlar')
    .replace("Sog'liqni saqlash vazirligi", 'SSV')
    .replace('Boshqarma ', "Boshq. ")
    .replace('Departament ', 'Dep. ')
    .replace('Metrologik xizmat', 'Metrol. xizmat')
    .replace("Moliya-iqtisodiy", "Mol.-iqt.")
    .replace("Axborot-tahliliy", "Axb.-tahl.")
    .replace("Poligrafiya", "Poligr.")
    .replace("Yuridik", "Yurid.")
    .replace("Sinov markazi", "Sinov m.");
  if (short.length > 30) short = short.substring(0, 28) + '…';
  return short;
}

/** Сокращение названия отдела с учётом текущего языка */
export function shortenDeptName(name) {
  if (!name) return '';
  if (name.length <= 25) return name;
  return i18n.language === 'uz' ? shortenDeptNameUz(name) : shortenDeptNameRu(name);
}

/** Сменить язык и сохранить в localStorage */
export function changeLanguage(lang) {
  i18n.changeLanguage(lang);
  localStorage.setItem('language', lang);
}

/** Получить текущий язык */
export function getCurrentLanguage() {
  return i18n.language || 'uz';
}
